import { render, staticRenderFns } from "./coComments.vue?vue&type=template&id=6010ba72&scoped=true&"
import script from "./coComments.vue?vue&type=script&lang=ts&"
export * from "./coComments.vue?vue&type=script&lang=ts&"
import style0 from "./coComments.vue?vue&type=style&index=0&id=6010ba72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6010ba72",
  null
  
)

export default component.exports